import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { List, X } from '@phosphor-icons/react';

const navItems = [
  { label: 'Home', path: '/' },
  { label: 'Shop', path: '/shop' },
];

interface HeaderProps {
  cartItemsCount?: number;
}

const Header: React.FC<HeaderProps> = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/' || location.pathname === '/home';
    }
    return location.pathname.startsWith(path);
  };

  const go = (path: string) => {
    navigate(path);
    setOpen(false);
  };

  return (
    <>
      <header className="va-header">
        <div className="va-container va-header-inner">
          <button className="va-logo" type="button" onClick={() => go('/')} aria-label="VakaAfrica home">
            <span className="va-logo-mark">VA</span>
            <span className="va-logo-text">VakaAfrica</span>
          </button>

          <nav className="va-nav" aria-label="Primary">
            {navItems.map((item) => (
              <button
                key={item.path}
                type="button"
                className={`va-nav-link${isActive(item.path) ? ' is-active' : ''}`}
                onClick={() => go(item.path)}
              >
                {item.label}
              </button>
            ))}
          </nav>

          <div className="va-header-actions">
            <button
              type="button"
              className="va-menu-btn"
              aria-label="Open menu"
              onClick={() => setOpen(true)}
            >
              <List size={20} weight="bold" />
            </button>
          </div>
        </div>
      </header>

      <div className={`va-mobile-nav${open ? ' is-open' : ''}`} role="dialog" aria-modal="true">
        <div className="va-mobile-panel">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
            <span className="va-logo-text">Menu</span>
            <button type="button" className="va-menu-btn" aria-label="Close menu" onClick={() => setOpen(false)}>
              <X size={18} weight="bold" />
            </button>
          </div>
          {navItems.map((item) => (
            <button
              key={item.path}
              type="button"
              className={`va-nav-link${isActive(item.path) ? ' is-active' : ''}`}
              style={{ textAlign: 'left', width: '100%' }}
              onClick={() => go(item.path)}
            >
              {item.label}
            </button>
          ))}
          <button type="button" className="va-btn va-btn-primary" style={{ marginTop: '1rem' }} onClick={() => go('/shop')}>
            Browse shop
          </button>
        </div>
      </div>
    </>
  );
};

export default Header;
